<div class="db-payment-info__title" *ngIf="!isMobile">
  <h3 class="payment-info" *ngIf="!(paymentMethods?.length && !hidePaymentOptions)">Payment info</h3>
  <div *ngIf="!hidePaypal && !hidePaymentOptions && !hidePaypalAB">
    <div class="mr20">
      <input class="ds-radio ds-radio-small" [ngClass]="{'ds-radio-green': currentSubscription?.trialBoosterClient && mode !== 'pro-level'}" type="radio" id="card" value="card" name="method"
             [checked]="paymentMethod === 'card'" (change)="onPaymentMethodChange('card')">
      <label for="card"><b>Credit card</b></label>
    </div>
    <div [dsTooltip]="'text_disabledPaypalTooltip' | dbText"
         [dsTooltipVisible]="!!isPaypalInvalidCode"
         [dsTooltipPosition]="'bottom'"
         [dsTooltipAlign]="'right'">
      <input class="ds-radio ds-radio-small" [ngClass]="{'ds-radio-green': currentSubscription?.trialBoosterClient && mode !== 'pro-level'}" type="radio" id="paypal" value="paypal" name="method"
             [checked]="paymentMethod === 'paypal'" (change)="onPaymentMethodChange('paypal')">
      <label class='ds-paypal-label'for="paypal" [ngClass]="{'disabled': isPaypalInvalidCode || (!currentSubscription?.trialClient && !!currentSubscription?.couponCode && currentSubscription?.couponCode !== '1wf')}"><b>PayPal</b></label>
    </div>
  </div>
</div>


<div [ngSwitch]="paymentMethod">
  <div *ngSwitchCase="'card'">
    <div class="db-payment-info__stripe-tabs" *ngIf="paymentMethods?.length && !hidePaymentOptions">
      <h4 [ngClass]="{'payment-dialog__tabs-active': activeTab === 'existingCards'}" (click)="changeTab('existingCards')">{{'text_paymentExistingCards' | dbText}}</h4>
      <h4 [ngClass]="{'payment-dialog__tabs-active': activeTab === 'addCard'}" (click)="changeTab('addCard')">{{'text_paymentAddCard' | dbText}}</h4>
    </div>
    <div class="db-payment-dialog__payment-methods" [ngClass]="{'hidden': useNewPaymentMethod || activeTab !== 'existingCards'}">
      <div class="db-payment-dialog__all-payment-methods">
        <db-payment-method-item [fromCheckout]="true" [fromUpgrade]="true" [withShadow]="true" [paymentMethod]="paymentMethod" [selectable]="true" [selected]="selectedPaymentMethod === paymentMethod" (onSelect)="selectPaymentMethod($event)" *ngFor="let paymentMethod of paymentMethods"></db-payment-method-item>
      </div>
      <span *ngIf="stripeErrors" class="ds-input-error-msg">{{stripeErrors}}</span>
      <span *ngIf="!stripeErrors && serverErrors" class="ds-input-error-msg">{{serverErrors?.message}}</span>
    </div>
<!--
    <h3 class="payment-info" *ngIf="paymentMethods?.length && !hidePaymentOptions && activeTab === 'addCard'">Payment info</h3>
-->
    <div class="db-apple-google-wrap ds-lazy-load" *ngIf="isMobile">
      <db-google-apple-pay
                           [user]="user"
                           [chosenPlan]="chosenPlan"
                           [newPrice]="newPrice"
      ></db-google-apple-pay>
      <div class="db-apple-google-temporary">A temporary $1 hold will verify your card and be refunded.</div>
      <div class="db-apple-google-or-card">
        <span>Or pay with card</span>
      </div>
    </div>
    <div class="ds-input-wrap static" [ngClass]="{'hidden': (activeTab !== 'addCard' && paymentMethods?.length), 'has-payment-methods': paymentMethods?.length}">
      <div id="stripe" class="ds-input-card" [ngClass]="{'StripeElement--invalid': stripeErrors, cardType : cardType }"></div>
      <span *ngIf="stripeErrors" class="ds-input-error-msg">{{stripeErrors}}</span>
      <span *ngIf="!stripeErrors && serverErrors" class="ds-input-error-msg">{{serverErrors?.message}}</span>
    </div>
    <div class="ds-payment-info__cards mb33 mt10" *ngIf="activeTab === 'addCard'">
      <div class="ds-payment-info__cards-wrapper" [ngClass]="{'db-for-demo': forDemo}">
        <div>
          <img src="assets/images/logos/payment/{{forDemo ? 'mastercard-demo' : 'mastercard-raw'}}.svg" alt="">
        </div>
        <div>
          <img src="assets/images/logos/payment/{{forDemo ? 'visa-demo' : 'visa'}}.svg" alt="" class="visa">
        </div>
        <div>
          <img src="assets/images/logos/payment/{{forDemo ? 'amex-demo' : 'amex'}}.svg" alt="">
        </div>
        <div>
          <img src="assets/images/logos/payment/{{forDemo ? 'discover-demo' : 'discover'}}.svg" alt="" class="discover">
        </div>
        <span></span>
        <img src="assets/images/logos/payment/{{forDemo ? 'stripe-demo' : 'stripe'}}.svg" alt="" class="stripe">
      </div>
    </div>
  </div>
  <div *ngSwitchCase="'paypal'" class="ds-payment-info__paypal mb31">
    <img src="assets/images/logos/payment/paypal.svg" alt="">
    <p>You will be redirected to the PayPal site after<br *ngIf="!paypalAsDefault">
      reviewing your order.</p>
  </div>
</div>

